const swipperCollectionList = {
  props: {
    dynamicClass: ".c-collection-list.dynamicLoading",
    className: ".JS-collection-link",
    collectionListSelector: ".c-swipper-collection-list",
    collectionListContentSelector: ".JS-collection-list__content",
    customMobileClass: "swiper-type-carouselCustom",
    cssSelector: "JS-collection-list_carousel",
    cssSelectorSwiper: ".swiper-wrapper[data-items-load]",
    nameAttr: "data-items-load",
    hidden: "hidden",
    config: {
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      slidesPerView: 1.1,
      spaceBetween: 0,
      loopedSlides: 1,
      loop: false,
      grabCursor: true,
      wrapperClass: "swiper-wrapper",
      breakpoints: {
        1024: {
          slidesPerView: 4,
        },
      },
    },
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-swipperCollectionList.css", this.props.dynamicClass);

    const collections = document.querySelectorAll(this.props.className);
    collections.forEach((collection) => {
      if (collection.dataset.selectorurl) {
        let url;
        if (collection.href.includes(".html")) {
          url = collection.href.split(".html")[0];
          collection.href = url + "--" + collection.dataset.selectorurl + ".html";
        } else {
          url = collection.href.slice(0, -1);
          collection.href = url + "--" + collection.dataset.selectorurl;
        }
      }
    });
    if (document.querySelector("." + this.props.cssSelector)) {
      this.handleMobile();
      bcl.u.swiper.init(document, this.props);
    }
  },
  handleMobile: function () {
    const elements = document.querySelectorAll(this.props.collectionListSelector);
    elements?.forEach((el) => {
      const content = el.querySelector(this.props.collectionListContentSelector);
      const carousel = el.querySelector("." + this.props.cssSelector);
      if (content && carousel) {
        if (bcl.u.mobile.isMobile()) {
          carousel.classList.add(this.props.customMobileClass);
          carousel.classList.remove(this.props.hidden);
          content.classList.add(this.props.hidden);
        } else {
          carousel.classList.remove(this.props.customMobileClass);
          if (carousel.dataset.collectionsSize && carousel.dataset.collectionsSize > 4) {
            content.classList.add(this.props.hidden);
          } else {
            carousel.classList.add(this.props.hidden);
            content.classList.remove(this.props.hidden);
          }
        }
      }
    });
  },
};

export default swipperCollectionList;
